import React from 'react';
import { Icon, IconProps } from '@chakra-ui/react';

const QuestionIcon = (props: IconProps) => {
  return (
    <Icon viewBox="0 0 24 24" {...props}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.0137 1.84814C5.96367 1.84814 1.01367 5.84814 1.01367 10.737C1.01367 13.0704 2.11367 15.2926 4.09367 16.8481C4.09367 17.5148 3.65367 19.2926 1.01367 21.8481C1.01367 21.8481 4.86367 21.8481 8.16367 19.0704C9.37367 19.4037 10.6937 19.6259 12.0137 19.6259C18.0637 19.6259 23.0137 15.6259 23.0137 10.737C23.0137 5.84814 18.0637 1.84814 12.0137 1.84814ZM13.1137 15.1815H10.9137V12.9593H13.1137V15.1815ZM15.0937 9.62592C14.7637 10.0704 14.3237 10.2926 13.8837 10.5148C13.5537 10.737 13.4437 10.8481 13.3337 11.0704C13.1137 11.2926 13.1137 11.5148 13.1137 11.8481H10.9137C10.9137 11.2926 11.0237 10.9593 11.2437 10.6259C11.4637 10.4037 11.9037 10.0704 12.4537 9.73703C12.7837 9.62592 13.0037 9.4037 13.1137 9.18148C13.2237 8.95926 13.3337 8.62592 13.3337 8.4037C13.3337 8.07037 13.2237 7.84814 13.0037 7.62592C12.7837 7.4037 12.4537 7.29259 12.1237 7.29259C11.7937 7.29259 11.5737 7.4037 11.3537 7.51481C11.1337 7.62592 11.0237 7.84814 11.0237 8.18148H8.82367C8.93367 7.4037 9.26367 6.73703 9.81367 6.29259C10.3637 5.84814 11.1337 5.73703 12.1237 5.73703C13.1137 5.73703 13.9937 5.95926 14.5437 6.4037C15.0937 6.84814 15.4237 7.51481 15.4237 8.29259C15.5337 8.73703 15.4237 9.18148 15.0937 9.62592Z"
          fill="white"
        />
      </svg>
    </Icon>
  );
};

export default QuestionIcon;
